import { Horizontal } from 'gls';
import React from 'react';
import styled from 'styled-components';
import { colours } from 'styling/colours';

type ButtonProps = {
  title?: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  disabledAction?: boolean;
  loading?: boolean;
  style?: React.CSSProperties;
  type?: 'reset' | 'submit' | undefined;
  id?: string;
  isLoading?: boolean;
  tabIndex?: number;
  ref?: any;
  ariaLabel: string;
  width?: number;
  height?: number;
  fill?: string;
};

const StyledButton = styled.button<ButtonProps>`
  background: transparent;
  border: 0;
  width: ${(props) => props.width ? props.width + "px" : "fit-content"};
  height: ${(props) => props.height ? props.height + "px" : "fit-content"};
  cursor: pointer;
  border-radius: 5px;
  & svg {
    fill: ${(props) => props.fill || "auto"};
  }
  &:disabled {
    cursor: not-allowed;
    & svg {
      & path {
        fill: ${colours.tertiaryText};
      }
    }
  }
  &:focus-visible {
    outline: 2px solid ${(props) => props.fill || colours.secondary};
    outline-offset: 1px;
  }
`;

const IconButton = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {

  return (
    <StyledButton
      {...props}
      ref={ref}
      title={props.title || props.ariaLabel}
      disabled={props.disabled || props.isLoading}
      aria-label={props.ariaLabel}
    >
      {props.children && (
        <Horizontal spacing={5}>
          {props.icon}
          {props.children}
        </Horizontal>
      )}
      {!props.children && props.icon}
    </StyledButton>
  )
});

IconButton.displayName = 'IconButton';
export default IconButton;
